import { gql } from '@apollo/client';

export interface IHostOccupationReportRequest {
  input: {
    from: string;
    to: string;
  };
}
export interface IHostOccupationReportResponse {
  hostsOccupationReport: {
    labels: Array<string>;
    extraLabels: Array<string>;
    keys: Array<string>;
    points: number;
    data: Array<{ values: Array<number> }>;
    summary: Array<{ title: string; value: number }>;
  };
}
export const GENERATE_HOSTS_OCCUPATION_REPORT = gql`
  query hostsOccupationReport($input: HostsOccupationReport!) {
    hostsOccupationReport(input: $input) {
      labels
      extraLabels
      keys
      points
      data {
        values
      }
      summary {
        title
        value
      }
    }
  }
`;

export interface IHostOccupationReportFileResponse {
  hostsOccupationReport: {
    url: string;
  };
}
export const GENERATE_HOSTS_OCCUPATION_REPORT_FILE = gql`
  query hostsOccupationReport($input: HostsOccupationReport!) {
    hostsOccupationReport(input: $input) {
      url
    }
  }
`;
